export default {
  order: [],
  warehouseReport: [],
}
